import { createTheme } from "@mui/material/styles";
const theme = createTheme({
  palette: {
    primary: {
      main: "#0077B2",
    },
    secondary: {
      main: "#d32f2f",
    },
  },
  typography: {
    fontFamily: "Graphik, sans-serif",
  },
});
export default theme;
